module.exports = __webpack_public_path__ + "img/win_paytable.25fb003d.png";